import React from "react";
import { Instagram, Youtube, Play } from "lucide-react";

const REELS = [
  { tag: "@execora", title: "Running for a tube light at 10pm", hue: "from-rose-200 to-amber-200" },
  { tag: "@execora", title: "Orchids in 42 minutes", hue: "from-emerald-200 to-lime-200" },
  { tag: "@execora", title: "A watch, a battery, a story", hue: "from-sky-200 to-indigo-200" },
  { tag: "@execora", title: "Dhobi diaries: Vol. 1", hue: "from-fuchsia-200 to-rose-200" },
];

export const SocialProof = () => {
  return (
    <section
      id="social"
      data-testid="social-proof-section"
      className="relative py-16 md:py-24 lg:py-28 bg-slate-50/60 border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <div className="text-xs tracking-[0.2em] text-[#65a30d] font-semibold uppercase">
              Stories from the lane
            </div>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.1]">
              Reels from real runs.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/execora.in"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-instagram-link"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium text-slate-700 border border-slate-200 hover:border-slate-300 hover:bg-white transition-colors"
            >
              <Instagram className="h-4 w-4" strokeWidth={2} />
              Instagram
            </a>
            <a
              href="https://youtube.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-youtube-link"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium text-slate-700 border border-slate-200 hover:border-slate-300 hover:bg-white transition-colors"
            >
              <Youtube className="h-4 w-4" strokeWidth={2} />
              YouTube
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {REELS.map((r, i) => (
            <div
              key={i}
              data-testid={`reel-card-${i}`}
              className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm hover:shadow-md transition-all"
              style={{ aspectRatio: "9 / 16" }}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${r.hue}`} />
              <div className="absolute inset-0 bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%22160%22 height=%22160%22><filter id=%22n%22><feTurbulence type=%22fractalNoise%22 baseFrequency=%220.9%22/></filter><rect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23n)%22 opacity=%220.18%22/></svg>')]" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="h-14 w-14 rounded-full bg-white/85 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 transition-transform">
                  <Play className="h-6 w-6 text-slate-900 ml-0.5" fill="currentColor" strokeWidth={1.5} />
                </div>
              </div>
              <div className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-slate-900/70 to-transparent text-white">
                <div className="text-[10px] tracking-widest uppercase opacity-80">{r.tag}</div>
                <div className="mt-0.5 text-sm font-semibold leading-snug">{r.title}</div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-xs text-slate-500">Reels shown are placeholders. Full playlist coming soon.</p>
      </div>
    </section>
  );
};

export default SocialProof;
